import { PreAuthServiceType, PreAuthStatus } from './constants';

export const getPreAuthStatus = (authId) =>
  Object.values(PreAuthStatus).find((status) => status.value === authId);

export const getPreAuthServiceType = (typeId) =>
  Object.values(PreAuthServiceType).find((type) => type.value === typeId)?.label || '-';
